import { render, staticRenderFns } from "./extraInfoLayout.pug?vue&type=template&id=70f9da81&lang=pug&"
import script from "./extraInfoLayout.js?vue&type=script&lang=js&"
export * from "./extraInfoLayout.js?vue&type=script&lang=js&"
import style0 from "./extraInfoLayout.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f9da81')) {
      api.createRecord('70f9da81', component.options)
    } else {
      api.reload('70f9da81', component.options)
    }
    module.hot.accept("./extraInfoLayout.pug?vue&type=template&id=70f9da81&lang=pug&", function () {
      api.rerender('70f9da81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/extraInfoLayout/index.vue"
export default component.exports